"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var Switch = function (props) {
    var checked = props.checked, disabled = props.disabled, size = props.size, className = props.className, style = props.style, showLabel = props.showLabel, handleToggle = props.onChange;
    var classes = classNames('form-control__switch', {
        'form-control__switch--large': size === 'large' || size === undefined,
        'form-control__switch--checked': checked,
        'form-control__switch--disabled': disabled,
        'form-control__switch-label': showLabel
    }, className);
    if (disabled) {
        return React.createElement("div", { className: classes, style: style });
    }
    return (React.createElement("div", { className: classes, style: style, onClick: function () {
            handleToggle(checked);
        } }));
};
exports.default = Switch;
//# sourceMappingURL=Switch.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/Switch/Switch.js
// module id = 276
// module chunks = 0